<ng-content></ng-content>
<div class="outlet-wrapper"><router-outlet></router-outlet></div>
